import React, { Component } from 'react'
import classnames from 'classnames'

/**
 * @description Component for render Sportnect icon from custom font
 *      USAGE
 *          <SnIcon
 *              *** PROPS ***
 *          />
 *
 *      PROPS - all props are optional
 *          isHoverable - if is defined, icon is hoverable
 *          notHoverClassName   - icon classes if is not hover (use only if prop 'isHoverable' is defined)
 *          hoverClassName      - icon classes if is hover (use only if prop 'isHoverable' is defined)
 *          className   - icon classes used for icon in all states (use icon class name only if prop 'isHoverable' is NOT defined)
 *          restProps   - all other props available as React says
 *
 */
export default class SnIcon extends Component {

    /**
     * Render hoverable icon
     * @return {*}
     */
    renderHoverable = () => {
        const inputProps = Object.assign({}, this.props)

        if (inputProps.isHoverable) {
            delete inputProps.isHoverable
        }

        const {
            className,
            hoverClassName,
            notHoverClassName,
            ...restProps
        } = inputProps

        return (
            <div className="sn-icon-hoverable">
                <span
                    className={classnames({
                        'sn-icon sn-icon-not-hover': true,
                        [className]: !!className,
                        [notHoverClassName]: !!notHoverClassName,
                    })}
                    {...restProps}
                />
                <span
                    className={classnames({
                        'sn-icon sn-icon-hover': true,
                        [className]: !!className,
                        [hoverClassName]: !!hoverClassName,
                    })}
                    {...restProps}
                />
            </div>
        )
    }

    /**
     * Render normal icon
     * @return {*}
     */
    renderNormal = () => {
        const inputProps = Object.assign({}, this.props)

        if (inputProps.isHoverable) {
            delete inputProps.isHoverable
        }

        const {
            className,
            ...restProps
        } = inputProps

        return (
            <span
                className={classnames({
                    'sn-icon': true,
                    [className]: !!className,
                })}
                {...restProps}
            />
        )
    }

    /**
     * Render method
     * @return {*}
     */
    render() {
        const { isHoverable } = this.props

        if (isHoverable) {
            return this.renderHoverable()
        }

        return this.renderNormal()
    }
}
